// React Component (NavBar.js)
import React, { useState } from "react";
import { Navbar, Nav, Container, Button, Dropdown } from "react-bootstrap";
import { assest } from "../Assest/Assest";
import "../css/Navbar.css";
import { Link } from "react-router-dom";

function NavBar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <Navbar expand="lg" className="custom-navbar" sticky="top">
      <Container>
        {/* Logo Section */}
        <Navbar.Brand href="/" className="d-flex align-items-center">
          <img
            style={{ width: "80px", height: "80px" }}
            src={assest.Logo}
            alt="Logo"
            className="navbar-logo"
          />
          <img
            style={{ width: "130px", height: "34px", marginLeft: "-12px" }}
            src={assest.Den}
            alt="Den Text"
            className="navbar-den"
          />
        </Navbar.Brand>

        {/* Toggle for Mobile */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        {/* Navbar Items */}
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto d-flex justify-content-center align-items-center ">
            <Nav.Link href="/" className="nav-item">
              Home
            </Nav.Link>

            {/* Treatments Dropdown */}
            <Dropdown
              className="nav-item custom-dropdown"
              show={isDropdownOpen}
              onClick={toggleDropdown}
            >
              <Dropdown.Toggle
                variant="link"
                id="dropdown-treatments"
                className="dropdown-toggle-no-arrow"
              >
                Treatments
              </Dropdown.Toggle>
              <Dropdown.Menu className="custom-dropdown-menu">
                <Dropdown.Item href="/TeethWhitening">Teeth Whitening</Dropdown.Item>
                <Dropdown.Item href="/DentalImplants">Dental Implants</Dropdown.Item>
                <Dropdown.Item href="/DenturesBridges">Dentures & Bridges</Dropdown.Item>
                <Dropdown.Item href="/FillingandSealants">Filling and Sealants</Dropdown.Item>
                <Dropdown.Item href="/OralSurgery">Oral Surgery</Dropdown.Item>
                <Dropdown.Item href="/RootCanals">Root Canals</Dropdown.Item>
                <Dropdown.Item href="/LaserDentistry">Laser Dentistry</Dropdown.Item>
                <Dropdown.Item href="/TeethReshaping">Teeth Reshaping</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Nav.Link href="/gallery" className="nav-item">
              Gallery
            </Nav.Link>
            <Nav.Link href="/testimonials" className="nav-item">
              Testimonials
            </Nav.Link>
            <Nav.Link href="/aboutus" className="nav-item">
              About Us
            </Nav.Link>
            <Nav.Link href="/contactus" className="nav-item">
              Contact Us
            </Nav.Link>
          </Nav>

          {/* Book Appointment Button */}
          <div className="book-btn-container">
            <Button className="book-bt" href="/bookanappointment">
              Book An Appointment
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;